import { Navigate } from 'react-router-dom';

import { SignIn } from '@/features/auth';

export const publicRoutes = [
  { path: '/', element: <SignIn /> },
  { path: '*', element: <Navigate to="." /> },
];
